import localforage from 'localforage';

localforage.config({
  name: 'knittime',
  storeName: 'knitting_state',
  description: 'Local storage for knitting patterns and sessions',
});

export default localforage;
